import { gql } from "@apollo/client";

export const AddStockGroup = gql`
  mutation AddStockGroup(
    $token: String!
    $group_name: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddStockGroup(
      token: $token
      group_name: $group_name
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateStockGroup = gql`
  mutation UpdateStockGroup(
    $token: String!
    $group_id: ID!
    $user_details: SubscribedUser!
    $group_name: String!
  ) {
    UpdateStockGroup(
      token: $token
      group_id: $group_id
      user_details: $user_details
      group_name: $group_name
    )
  }
`;

export const DeleteStockGroup = gql`
  mutation DeleteStockGroup(
    $token: String!
    $group_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteStockGroup(
      token: $token
      group_id: $group_id
      user_details: $user_details
    )
  }
`;
